import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-tfa',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule],
  templateUrl: './tfa.component.html',
  styleUrl: './tfa.component.css'
})

export class TfaComponent implements OnInit {
  user: String = ""
  tfaForm: FormGroup = new FormGroup({
    tfa: new FormControl(['', [Validators.required, Validators.pattern("^[0-9]{6}$")]])
  })
  constructor(private authService: AuthService, private router: Router, private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      let user = params['user'];
      this.user = user;
    });
    this.buildForm();
  }

  buildForm() {
    this.tfaForm = this.formBuilder.group({
      tfa: ['', [Validators.required, Validators.pattern("^[0-9]{6}$")]]
    });
  }

  login(tfa : any) {
    this.authService.tfa({ tfa: tfa.tfa, UserName: this.user }).subscribe(
      (data : any) => {
        sessionStorage.setItem('token', JSON.stringify(data));
        sessionStorage.setItem('user', tfa.UserName);
        this.authService.isInRole('Admin').subscribe((data) => {
          if (data == true) {
            this.router.navigate(['Admin']);
          }
          else {
            this.router.navigate(['']);
          }
        });
      });
  }
}
